/** All possible values for tag groups */
export enum TagGroups {
    Market = 'Market',
    Individual = 'Individual',
    Work = 'Work'
}
